module.exports = __webpack_public_path__ + "static/media/owl.9e08f5b8.png";